export const AccountabilityReceiptStatusLabel = {
  0: 'Pendiente',
  1: 'Aceptado',
  2: 'Rechazado',
  3: 'Corrección'
};
